export function parseThemePreference(value) {
    return value === 'light' || value === 'dark' ? value : 'system';
}
export function readThemePreference(storageKey) {
    try {
        return parseThemePreference(window.localStorage.getItem(storageKey));
    }
    catch {
        return 'system';
    }
}
/** Self-contained so Vite can inline this exact function before any app/CSS
 * loads. Do not capture imports or module constants in this function. */
export function initializeTheme(storageKey) {
    let saved = null;
    try {
        saved = window.localStorage.getItem(storageKey);
    }
    catch { /* blocked storage */ }
    const preference = saved === 'light' || saved === 'dark' ? saved : 'system';
    const dark = preference === 'dark' || (preference === 'system'
        && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    const theme = dark ? 'dark' : 'light';
    document.documentElement.dataset.colorTheme = theme;
    return { preference, theme };
}
/** Inlined by each app's Vite config before CSS and React. Pure entry point:
 * importing it in Node must not load React or browser-only assets. */
export function themeBootstrapPlugin(storageKey) {
    return {
        name: 'theme-before-paint',
        transformIndexHtml: {
            order: 'pre',
            handler: (html) => {
                const marker = '<!-- theme-bootstrap -->';
                if (!html.includes(marker))
                    throw new Error('Missing <!-- theme-bootstrap --> marker');
                return html.replace(marker, () => `<script>(${initializeTheme.toString()})(${JSON.stringify(storageKey)});</script>`);
            },
        },
    };
}
//# sourceMappingURL=theme-preference.js.map